import { createContext, useContext } from "react";
import { SiteMeta } from "../../data/SiteMeta";
import { PageMeta } from "../../data/PageMeta";



const PageContext = createContext<PageContextType>({} as PageContextType);

export const PageContextProvider = PageContext.Provider;
export const usePageContext = () => useContext(PageContext);

export type PageContextType = {
	siteMeta: SiteMeta;
	pageMeta: PageMeta;
}
